
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import logo from '../../../assets/images/logo.png';
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";

class AuthBanner extends Component {
    render() {
        const { t, title, subtitle, authText, buttonTitle, buttonLink } = this.props;

        return (
            <div className='auth-banner-container'>
                <div className="logos">
                    <img src={logo} alt="Logo" />
                    <span>{t('login.logosText')}</span>
                </div>
                <div className="content">
                    <div
                        className='title'
                        dangerouslySetInnerHTML={{ __html: title }}
                    />
                    <div
                        className='subtitle'
                        dangerouslySetInnerHTML={{ __html: subtitle }}
                    />
                    <ul>
                        {authText.map((item, index) => (
                            <li key={index}>
                                <div dangerouslySetInnerHTML={{ __html: item }} />
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="button">
                    <Link to={buttonLink}>{buttonTitle}</Link>
                </div>
            </div>
        );
    }
}

AuthBanner.propTypes = {
    t: PropTypes.any,
    title: PropTypes.any,
    subtitle: PropTypes.any,
    authText: PropTypes.array,
    buttonTitle: PropTypes.any,
    buttonLink: PropTypes.any
};

export default withTranslation()(AuthBanner);
